import { useMutation, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import {
  updateAvailabilityRequestStatus,
  type AvailabilityStatus,
} from '@sportninja/common/services/game/availabilityRequestService'
import type { LandingNotification } from '@sportninja/common/features/notifications/types/landing'

export const useAvailabilityRequestActions = () => {
  const queryClient = useQueryClient()
  const mutation = useMutation({ mutationFn: updateAvailabilityRequestStatus })

  const setAvailability = async (
    n: LandingNotification,
    status: AvailabilityStatus
  ): Promise<void> => {
    const gameId = n.data?.entity_id
    const requestId = n.data?.availability_request_uid
    if (!gameId || !requestId) {
      return Promise.reject(
        new Error('Missing game or availability request id')
      )
    }
    await mutation.mutateAsync({ gameId, requestId, status })
    // Refetch the game's roster players so the attendance modal shows the new
    // availability next time it opens. The notification only carries the game
    // id (not the roster id), so invalidate by the [gameRosterPlayers, gameId]
    // prefix — React Query matches every roster under that game.
    queryClient.invalidateQueries({
      queryKey: [...queryKeys.gameRosterPlayers.all, gameId],
    })
  }

  return { setAvailability, isPending: mutation.isPending }
}
